import { TEST_CONSTANTS } from '../constants';

export function generateTestVersionString(): string {
  return `v${TEST_CONSTANTS.ADAPTIVE_VERSION}`;
}
